import { Trans, useLingui } from '@lingui/react/macro';
import { Pages } from 'modules/navigation/domain/enums/pages';
import useBoards from 'modules/template-editor/ui/hooks/use-boards';
import useTemplates from 'modules/template-editor/ui/hooks/use-templates';
import { useMemo } from 'react';
import { theme } from 'styles/theme/theme';
import { DivProps } from 'typings';
import UDText from 'ud-ui/components/text';
import PopupControl from './popup-control';
import { PanelItemWrapper } from './styles';

/**
 * Табло типа TV — то, что показывают на экране в зале: без джойстика и без переключения
 * табло из трансляции. Раньше для него копировали отдельную ссылку с номером табло; теперь
 * панель находит его в шаблоне сама, потому что шаблон известен только после старта матча.
 */
function TvBoardControl(props: DivProps) {
  const { className = '', ...rest } = props;
  const { t } = useLingui();
  const { boards } = useBoards();
  const { activeTemplate } = useTemplates();

  const tvBoard = useMemo(() => boards.find((board) => board.type === 'tv'), [boards]);
  const templateName = activeTemplate?.name ?? t`без названия`;

  if (!tvBoard) {
    return (
      <PanelItemWrapper className={'flex flex-col gap-2 ' + className} {...rest}>
        <UDText type={'headline'} color={theme.colors.Gray}>
          <Trans>Экран в зале (TV)</Trans>
        </UDText>
        <UDText type={'subhead'} color={'white'}>
          <Trans>В шаблоне «{templateName}» нет табло с типом TV, поэтому запускать нечего.</Trans>
        </UDText>
        <UDText type={'subhead'} color={'white'}>
          <Trans>Откройте шаблон, добавьте табло и выберите у него тип «TV» — кнопка запуска появится здесь сама.</Trans>
        </UDText>
        {activeTemplate && (
          <a
            href={Pages.TEMPLATE.builders.boards(activeTemplate.id)}
            target={'_blank'}
            rel={'noreferrer'}
            style={{ color: theme.colors.EditorAccentBlue }}
          >
            <UDText type={'subhead'} color={theme.colors.EditorAccentBlue}>
              <Trans>Открыть шаблон «{templateName}»</Trans>
            </UDText>
          </a>
        )}
      </PanelItemWrapper>
    );
  }

  const tvBoardName = tvBoard.name;

  return (
    <PanelItemWrapper className={'flex flex-col gap-2 ' + className} {...rest}>
      <UDText type={'headline'} color={theme.colors.Gray}>
        <Trans>Экран в зале (TV)</Trans>
      </UDText>
      <UDText type={'subhead'} color={'white'}>
        <Trans>Табло «{tvBoardName}» откроется в отдельном окне: без джойстика и без смены табло из трансляции.</Trans>
      </UDText>
      <PopupControl boardId={tvBoard.id} isLocked isHidePanel />
    </PanelItemWrapper>
  );
}

export default TvBoardControl;
